module.exports = __webpack_public_path__ + "img/branch-privileges.eef37244.svg";